import { forwardRef } from 'react'

import { TextField } from './TextField'

interface NumberFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string | null
  helpText?: string
  inputClassName?: string
  padLength?: number
}

const clampNumber = (value: number, min?: number, max?: number) => {
  if (min !== undefined && value < min) return min
  if (max !== undefined && value > max) return max
  return value
}

const NumberField = forwardRef<HTMLInputElement, NumberFieldProps>(
  ({ onChange, padLength, ...props }, ref) => {
    const { maxLength = 0, min, max } = props
    const effectivePadLength = padLength || maxLength

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.target.value = e.target.value
        .replace(/\D/g, '')
        .slice(0, maxLength || undefined)
      onChange?.(e)
    }

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      const { value } = e.target
      if (!value) return onChange?.(e)

      const normalizedValue = String(
        clampNumber(
          Number(value),
          Number(min) || undefined,
          Number(max) || undefined,
        ),
      )
      e.target.value =
        effectivePadLength && normalizedValue.length < effectivePadLength
          ? normalizedValue.padStart(effectivePadLength, '0')
          : normalizedValue
      onChange?.(e)
    }

    return (
      <TextField
        {...props}
        onChange={handleChange}
        onBlur={handleBlur}
        ref={ref}
      />
    )
  },
)

NumberField.displayName = 'NumberField'

export { NumberField }
